import { createApp } from 'vue'
import App from './App.vue'

export const api_url = document.odhapiurl;
export const web_url = document.odhweb;

createApp(App).mount('#app')
